module.exports = __webpack_public_path__ + "static/media/enterMeta.7eff09b5.gif";